<template>
<div class="chapter">
<div class="inner_page">
<p style="margin: 0; padding: 0; text-align: center"><img alt="The Exponential Age" src="images/title.png" style="padding: 0; margin: 0; height:100%;"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f002.vue?cc465950